<template>
  <el-popover placement="bottom-end" trigger="click" :width="280" popper-class="cs-notification-popover">
    <div class="settings-panel">
      <div class="settings-title">通知設定</div>

      <div class="settings-row">
        <span class="row-label">音效通知</span>
        <span class="row-actions">
          <el-button type="text" size="mini" class="mini-link" @click="handleTestSound">測試</el-button>
          <el-switch v-model="soundEnabled" @change="handleSoundChange" />
        </span>
      </div>

      <div class="settings-row">
        <span class="row-label">桌面彈窗</span>
        <el-switch v-model="popupEnabled" @change="handlePopupChange" />
      </div>

      <div class="perm-section">
        <div class="settings-row">
          <span class="row-label sub">瀏覽器通知</span>
          <span class="row-actions">
            <el-tag :type="permTagType" size="mini" class="perm-tag">{{ permText }}</el-tag>
            <el-button
              v-if="permStatus === 'default'"
              type="text"
              size="mini"
              class="mini-link"
              @click="handleRequestPermission"
            >授權</el-button>
            <el-tooltip v-if="permStatus === 'denied'" content="瀏覽器已封鎖通知權限，需手動解除" placement="top">
              <i class="el-icon-question question-icon" />
            </el-tooltip>
          </span>
        </div>

        <div v-if="permStatus === 'denied'" class="perm-hint">
          Chrome 已封鎖此網站的通知權限，請手動開啟：
          <ol>
            <li>點擊網址列左側的 <strong>鎖頭</strong>（或 ⓘ）圖示</li>
            <li>找到「<strong>通知</strong>」，改為「<strong>允許</strong>」</li>
            <li>重新整理頁面即可生效</li>
          </ol>
        </div>
      </div>
    </div>

    <div slot="reference" class="bell-trigger">
      <i class="el-icon-bell" />
      <span v-if="permStatus === 'denied'" class="bell-dot" />
    </div>
  </el-popover>
</template>

<script>
import {
  getNotificationPrefs,
  setNotificationPrefs,
  requestNotificationPermission,
  getPermissionStatus,
  playNotificationSound
} from './useNotification'

export default {
  name: 'NotificationSettings',
  data() {
    const prefs = getNotificationPrefs()
    return {
      soundEnabled: prefs.soundEnabled,
      popupEnabled: prefs.popupEnabled,
      permStatus: getPermissionStatus()
    }
  },
  computed: {
    permTagType() {
      const map = { granted: 'success', denied: 'danger', default: 'warning', unsupported: 'info' }
      return map[this.permStatus] || 'warning'
    },
    permText() {
      const map = { granted: '已授權', denied: '已拒絕', default: '未授權', unsupported: '不支援' }
      return map[this.permStatus] || '未授權'
    }
  },
  methods: {
    handleSoundChange(checked) {
      setNotificationPrefs({ soundEnabled: !!checked })
    },
    handlePopupChange(checked) {
      const on = !!checked
      setNotificationPrefs({ popupEnabled: on })
      if (on && this.permStatus !== 'granted') {
        requestNotificationPermission().then(result => {
          this.permStatus = result === 'unsupported' ? 'unsupported' : result
        })
      }
    },
    handleRequestPermission() {
      requestNotificationPermission().then(result => {
        this.permStatus = result === 'unsupported' ? 'unsupported' : result
      })
    },
    handleTestSound() {
      playNotificationSound()
    }
  }
}
</script>

<style scoped>
.bell-trigger {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 16px;
  color: #5a5e66;
}
.bell-trigger:hover {
  background: rgba(0, 0, 0, 0.025);
}
.bell-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f56c6c;
}
.settings-panel {
  width: 100%;
}
.settings-title {
  font-weight: 600;
  font-size: 14px;
}
.settings-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.row-label {
  font-size: 14px;
}
.row-label.sub {
  font-size: 12px;
  color: #909399;
}
.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mini-link {
  padding: 0;
  font-size: 12px;
}
.perm-tag {
  margin: 0;
}
.question-icon {
  color: #909399;
  cursor: pointer;
}
.perm-section {
  border-top: 1px solid #ebeef5;
  margin-top: 12px;
  padding-top: 8px;
}
.perm-hint {
  margin-top: 6px;
  font-size: 11px;
  color: #909399;
  line-height: 1.6;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 6px 8px;
}
.perm-hint ol {
  margin: 4px 0 0;
  padding-left: 16px;
}
</style>
